<template lang="pug">
      v-card(style="background:#F5F5F5")
        v-flex(xs12, style='margin-bottom:10px;padding-top:10px')
          v-flex(xs6, offset-xs3, class="elevation-2", style='background-color:white')
                v-card-title
                  span.headline Registro de Usuario
                v-layout(align-center, justify-center, row, wrap fill-height)
                    v-flex(xs8)
                        v-text-field#usuario(v-model='form.nombreUsuario' outlined label='Nombre de Usuario')
                    v-flex(xs8)
                        v-text-field#correo(v-model='form.correoUsuario' outlined label='Correo Electrónico')
                    v-flex(xs8)
                        v-text-field.input-group--focused(:append-icon="show3 ? 'visibility' : 'visibility_off'",
                        :type="show3 ? 'text' : 'password'",
                        label='Contraseña'
                        v-model="form.contrasenna"
                        outlined
                        @click:append='show3 = !show3')
        v-spacer
          v-flex(xs6, offset-xs3, class="elevation-2", style='margin-bottom:40px;margin-top:20px;background-color:white')
            v-card-title
              span.headline Registro de Empresa
            v-layout(align-center, justify-center, row, wrap fill-height)
                v-flex(xs8)
                    v-text-field(v-model='form.nombreEmpresa' outlined label='Nombre de la Empresa')
                v-flex(xs8)
                  div
                    div(class="d-flex justify-space-around")
                      div( class="pa-0 mr-2" style="width:70px")
                        v-select(v-model='rifLetra' :items='items' outlined)
                      div( class="pa-0")
                        v-text-field(v-model='rifNumerico' hint="Requerido" persistent-hint label='Rif' outlined v-mask="'#########'")
                v-flex(xs8)
                    v-text-field(
                      v-model='form.dir',
                      outlined,
                      label='Direccion',
                      v-uppercase)
                v-flex(xs8)
                    v-text-field#webEmpresa(v-model='form.paginaWeb' outlined label='Pagina web')
                v-flex(xs8)
                    v-text-field#correo2(v-model='form.correoEmpresa' outlined label='Correo electronico')
                v-flex(xs8)
                    v-text-field(v-model='form.telf' outlined label='Telefono' v-mask="'(####)###-##-##'")
                v-flex(xs8)
                  img(:src='ruta + img' v-if='img && !form.imagen.imageUrl' style='width:310px;height:auto')
                  img(:src='form.imagen.imageUrl' v-if='form.imagen.imageUrl' style='width:310px;height:auto')
                  v-text-field(style='height: 56px;margin: 0px 0px 10px;' outlined label='Logo' @click='pickFile' v-model='img' prepend-inner-icon='attach_file')
                  input(type='file' style='display: none' ref='image' accept='image/*' @change='onFilePicked')
          v-flex(xs12, style='margin-top:10px')
            v-layout(align-center, justify-center, row, wrap fill-height)
                v-btn(color="error" dark, @click.native='login' class="mb-5 mx-5") Cancelar
                v-btn(color="success" dark, @click='save()' class="mb-5") Registrarse
</template>

<script>
import Api from '@/services/methods'
import { server, port } from '../services/environment'
export default {
  data: () => ({
    ruta: server + ':' + port,
    img: '',
    show3: false,
    rifNumerico: '',
    rifLetra: 'V',
    form: {
      nombreUsuario: '',
      correoUsuario: '',
      contrasenna: '',
      nombreEmpresa: '',
      rif: '',
      dir: '',
      paginaWeb: '',
      correoEmpresa: '',
      telf: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    },

    items: ['V', 'E', 'J', 'P', 'G', 'C'],

    editedIndex: -1,
    defaultItem: {
      nombre: '',
      email: '',
      password: ''
    }
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {},
    login () {
      window.location.href = '/Login'
    },
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let peso = false
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) {
            peso = true
          }
        }
        if (peso === false) {
          this.form.imagen.imageName = files[0].name
          if (this.form.imagen.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.form.imagen.imageUrl = fr.result
            this.form.imagen.imageFile = files[0]
          })
        } else {
          this.$swal.fire(
            'Oops...',
            'Error encontrado, la imagen debe pesar menos de 4MB.',
            'error'
          )
          this.files = []
          this.form.imagen = []
        }
      } else {
        this.form.imagen.imageName = ''
        this.form.imagen.imageFile = ''
        this.form.imagen.imageUrl = ''
      }
    },

    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },

    validarCorreo (correo) {
      const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!validate.test(correo)) {
        return true
      }
      return false
    },

    validarWeb (paginaWeb) {
      const validate = /^(www|http:\/\/)(.*\.(com$|net$|org$))/
      if (!validate.test(paginaWeb)) {
        return true
      }
      return false
    },

    validarCampos () {
      if (
        this.form.nombreUsuario === '' ||
        this.form.correoUsuario === '' ||
        this.form.contrasenna === '' ||
        this.form.nombreEmpresa === '' ||
        this.rifLetra === '' ||
        this.rifNumerico === '' ||
        this.form.direccion === '' ||
        this.form.paginaWeb === '' ||
        this.form.correoEmpresa === '' ||
        this.form.telf === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      } else if (
        this.form.nombreUsuario.length > 40
      ) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Ha excedido el limite de caracteres'
        })
        return true
      } else if (this.form.telf.length !== 15) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text:
            'El campo de telefono debe tener 15 digitos, por favor verifique'
        })
        return true
      } else if (this.rifNumerico.length < 7) {
        this.$swal({
          icon: 'error',
          title: 'Rif invalido',
          text: 'El rif debe tener entre 7 a 9 caracteres'
        })
        return true
      } else if (this.validarCorreo(this.form.correoUsuario)) {
        this.$swal({
          icon: 'error',
          title: 'Correo invalido!',
          text: 'El correo de usuario ingresado no cumple con el debido formato'
        })
        return true
      } else if (this.validarCorreo(this.form.correoEmpresa)) {
        this.$swal({
          icon: 'error',
          title: 'Correo invalido!',
          text: 'El correo de la empresa ingresado no cumple con el debido formato'
        })
        return true
      } else if (
        this.validarWeb(this.form.paginaWeb)
      ) {
        this.$swal({
          icon: 'error',
          title: 'Pagina Web invalida!',
          text: 'La Pagina Web ingresada no cumple con el debido formato'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampos() /* !this.validarWeb(this.form.paginaWeb) */) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.concatenarRif()
        const data = new FormData()
        Object.keys(this.form).map(key => {
          if (Array.isArray(this.form[key])) {
            this.form[key].forEach(val => {
              if (typeof val === 'object' && val !== null) {
                return data.append(`${key}[]`, JSON.stringify(val))
              }
              return data.append(`${key}[]`, val)
            })
          } else if (
            typeof this.form[key] === 'object' &&
            this.form[key] !== null
          ) {
            return data.append(key, JSON.stringify(this.form[key]))
          } else {
            return data.append(key, this.form[key])
          }
        })
        if (this.form.imagen.imageFile) {
          data.append('imagen', this.form.imagen.imageFile)
        }
        Api.post('usuario/empresa', data)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm)
            this.$swal(
              'Felicidades.!',
              'Registro realizado exitosamente',
              'success'
            )
            window.location.href = '/Login'
          })
          .catch(err => {
            console.log(err)
            this.$swal(
              'Oops...',
              'Error encontrado, verifique los datos o llame al administrador.',
              'error'
            )
          })
      }
    }
  }
}
</script>
